export default __webpack_public_path__ + "assets/fonts/DMSans-Italic.woff2";